import { render, staticRenderFns } from "./DocumentDownloads.vue?vue&type=template&id=1e84c088&scoped=true&"
import script from "./DocumentDownloads.vue?vue&type=script&lang=js&"
export * from "./DocumentDownloads.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDownloads.vue?vue&type=style&index=0&id=1e84c088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e84c088",
  null
  
)

export default component.exports